module.exports = __webpack_public_path__ + "img/ico-add-blue.d3828e8f.svg";